module.exports = __webpack_public_path__ + "img/manager.309a1a36.svg";